(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 164);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var transformNodeText = function transformNodeText(text) {
  return text.toLowerCase().trim().replace(/[\s\-\.]/g, '_');
};

var getCompanyFromNode = function getCompanyFromNode(node) {
  var companyNode = node.querySelector(".project-overlay__company");

  return transformNodeText(companyNode.innerHTML);
};

var convertLanguage = {
  'ca_en': 'en_CA',
  'ko': 'ko_KR',
  'fi': 'fi_FI',
  'zh': 'zh_CH',
  'au': 'en_AU',
  'gb': 'en_GB',
  'la_es': 'es_LATAM',
  'ca_fr': 'fr_CA'
};

var getVideoPayload = function getVideoPayload(node, currentPage) {
  var lang = convertLanguage[currentPage];
  var current_page = getCurrentPage(currentPage);
  var feature = node.getAttribute('data-feature');

  return lang ? { region: lang, feature: feature } : { current_page: current_page, feature: feature };
};

var getDownloadPayload = function getDownloadPayload(node, currentPage) {
  var lang = convertLanguage[currentPage];
  var current_page = getCurrentPage(currentPage);
  var platform = node.getAttribute('data-platform');

  return lang ? { region: lang, platform: platform } : { current_page: current_page, platform: platform };
};

var getCurrentPage = function getCurrentPage(pagename) {
  var regional = isRegionalPage(pagename);

  if (pagename.match(/\./)) return pagename.split('.')[1];

  return regional || pagename;
};

var isRegionalPage = function isRegionalPage(currentPage) {
  return convertLanguage[currentPage];
};

var getHref = function getHref(node) {
  return transformNodeText(node.getAttribute('href'));
};

var getRegionalHeaderLinkName = function getRegionalHeaderLinkName(node) {
  var linkName = node.getAttribute('data-link-name');
  if (linkName) return linkName;

  var splitHref = node.href.split('/');
  var clickedLink = splitHref[splitHref.length - 1].replace('-', '_');

  return clickedLink === '' ? "en_US" : convertLanguage[clickedLink];
};

var featureExploreEventName = function featureExploreEventName(pagename) {
  var regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.feature_explore.click' : 'splash.feature_explore.click';
};

var downloadEventName = function downloadEventName(pagename) {
  var regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.download.click' : 'splash.product.download.click';
};

module.exports = {
  transformNodeText: transformNodeText,
  getCompanyFromNode: getCompanyFromNode,
  getHref: getHref,
  getCurrentPage: getCurrentPage,
  getRegionalHeaderLinkName: getRegionalHeaderLinkName,
  convertLanguage: convertLanguage,
  getVideoPayload: getVideoPayload,
  getDownloadPayload: getDownloadPayload,
  featureExploreEventName: featureExploreEventName,
  downloadEventName: downloadEventName
};

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
exports.jsonpSuccess = jsonpSuccess;
exports.detectUserCountry = detectUserCountry;
exports.changePhoneNumbers = changePhoneNumbers;
exports.openNewWindow = openNewWindow;
exports.getParameterByName = getParameterByName;
exports.insertUtmInForms = insertUtmInForms;
exports.insertUtmInFormsFields = insertUtmInFormsFields;
exports.convertMonthFormat = convertMonthFormat;
exports.convertTimeFormat = convertTimeFormat;
exports.convertTimezone = convertTimezone;
exports.embbedSvgImages = embbedSvgImages;
exports._ = _;
exports.showPopUp = showPopUp;
exports.getClosest = getClosest;
/*
 * Syntatic sugar
 */
var qs = exports.qs = function qs(x) {
  return document.querySelector(x);
};

var qsa = exports.qsa = function qsa(x) {
  return document.querySelectorAll(x);
};

/*
 * Custom get a cookie value
 */
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/*
 * callback for detectUserCountry ajax call
 */
function jsonpSuccess(response) {

  document.cookie = 'userCountry=' + response.country;
  userCountry = response.country;

  changePhoneNumbers(userCountry);
}

/*
 * Detect user country and change phones
 */

function detectUserCountry() {

  //Check user location
  var userCountry = getCookie('userCountry');
  if (userCountry === '') {

    var scr = document.createElement('script');
    scr.src = '//ipinfo.io?callback=jsonpSuccess';
    document.body.appendChild(scr);
  } else {
    changePhoneNumbers(userCountry);
  }
}

function changePhoneNumbers(userCountry) {

  switch (userCountry) {

    case 'AU':
      qs('.conditional-phone-number-small').innerHTML('1800 316 406');
      qs('.conditional-phone-number-big').innerHTML('1800 316 406');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+611800316406');
      break;

    case 'GB':
      qs('.conditional-phone-number-small').innerHTML('020 3695 0292');
      qs('.conditional-phone-number-big').innerHTML('+44 (0)20 3695 0292');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+4402036950292');
      break;

    case 'US':
      qs('.conditional-phone-number-small').innerHTML('800-646-0796');
      qs('.conditional-phone-number-big').innerHTML('+1 (800) 646-0796');
      qs('.conditional-phone-number-link').setAttribute('href', 'tel:+18006460796');
      qs('.int-locations').before(qs('.us-locations'));
      break;

  }
}

function openNewWindow() {
  qs("a.btn").setAttribute("target", "_blank");
  qs("a.button").setAttribute("target", "_blank");
}

/*
 * Get query values on URL
 */
function getParameterByName(name, url) {

  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[\[\]]/g, "\\$&");

  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
 * Automatically insert UTM variables on forms
 */
function insertUtmInForms() {

  var utmList = ['utm_source', 'utm_medium', 'utm_campaign'],
      check = '';

  for (var i = 0; i < utmList.length; i++) {

    check = getParameterByName(utmList[i]);
    if (check !== null && check !== '') {
      insertUtmInFormsFields(utmList[i], check);
    }
  }
}

function insertUtmInFormsFields(name, value) {
  if (qs('form')) {
    qs('form').prepend('<input type="hidden" name="' + name + '" value="' + value + '" />');
  }
}

insertUtmInForms();

/*
 * Convert Month Format
 */
function convertMonthFormat(date, format) {

  months = {
    'JAN': '01',
    'FEB': '02',
    'MAR': '03',
    'APR': '04',
    'MAY': '05',
    'JUN': '06',
    'JUL': '07',
    'AUG': '08',
    'SEP': '09',
    'OCT': '10',
    'NOV': '11',
    'DEC': '12'
  };
  year = new Date().getFullYear();

  if (format == 'google') {

    day = parseInt(date.replace(/\D/g, ''));
    if (day < 10) {
      day = '0' + day;
    }

    date = date.toUpperCase();

    Object.keys(months).forEach(function (item, index) {
      if (date.search(item) >= 0) {
        month = months[item];
        return false;
      }
    });

    return '' + year + '' + month + '' + day;
  }
}

function convertTimeFormat(date) {

  hours = date.split('-');
  if (hours[0].search("am") >= 0) {

    start = hours[0].trim().replace('am', '');

    if (start.search(':') >= 0) {

      start.replace(':', '');
      if (start.length < 4) {
        start = '0' + start;
      }

      start = '' + start + '00';
    } else {

      if (start.length < 2) {
        start = '0' + start;
      }

      start = '' + start + '0000';
    }
  } else {

    start = hours[0].trim().replace('pm', '');

    if (start.search(':') >= 0) {

      start.replace(':', '');
    }

    start = parseInt(start) + 1200;
    start = '' + start + '00';
  }

  if (hours[1].search("am") >= 0) {

    end = hours[1].trim().replace('am', '');

    if (end.search(':') >= 0) {

      end.replace(':', '');

      if (end.length < 4) {
        end = '0' + end;
      }
    } else {
      if (end.length < 2) {
        end = '0' + end + '00';
      }

      end = '' + end + '0000';
    }
  } else {

    end = hours[1].trim().replace('pm', '');

    if (end.search(':') >= 0) {

      end.replace(':', '');
    }

    end = parseInt(end) * 100 + 1200;
    end = '' + end + '00';
  }

  return { 0: start, 1: end };
}

function convertTimezone(timezone, startDate) {

  switch (timezone) {
    case "Atlantic":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "ADT";
      } else {
        timeZone = "AST";
      }
      break;

    case "Alaska":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "AKDT";
      } else {
        timeZone = "AKST";
      }
      break;

    case "Central":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "CDT";
      } else {
        timeZone = "CST";
      }
      break;

    case "Eastern":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "EDT";
      } else {
        timeZone = "EST";
      }
      break;

    case "Hawaii":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "HADT";
      } else {
        timeZone = "HAST";
      }
      break;

    case "Mountain":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "MDT";
      } else {
        timeZone = "MST";
      }
      break;

    case "Newfoundland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "NDT";
      } else {
        timeZone = "NST";
      }
      break;

    case "Pacific":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PDT";
      } else {
        timeZone = "PST";
      }
      break;

    case "Pierre & Miquelon":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "PMDT";
      } else {
        timeZone = "PMST";
      }
      break;

    case "Western Greenland":
      if (startDate.indexOf("Daylight") > -1) {
        timeZone = "WGST";
      } else {
        timeZone = "WGT";
      }
      break;

    default:
      timeZone = "";

  }

  return timeZone;
}

/*
 * Replace all SVG images with inline SVG
 */
function embbedSvgImages() {
  var parser = new DOMParser();

  qsa('img.svg').forEach(function (item, index) {
    //console.log('item',item);
    var img = item;
    var imgID = img.id;
    var imgClass = img.classList.item(0);
    var imgURL = img.getAttribute('src');

    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === XMLHttpRequest.DONE && httpRequest.status === 200) {
        var data = httpRequest.responseText;
        var doc = parser.parseFromString(data, "image/svg+xml");

        var svg = doc.querySelector('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          svg.setAttribute('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          svg.classList.add(imgClass);
          svg.classList.add('replaced-svg');
        }

        svg.removeAttribute('xmlns:a');

        img.parentNode.appendChild(svg);
        img.remove();
      }
    };
    httpRequest.open('GET', imgURL);
    httpRequest.send();
  });
}

/*
 * pure JS fade
 */

function _(el) {
  if (!(this instanceof _)) {
    return new _(el);
  }
  this.el = document.getElementById(el);
}

_.prototype.fade = function fade(type, ms) {
  var isIn = type === 'in',
      opacity = isIn ? 0 : 1,
      interval = 50,
      duration = ms,
      gap = interval / duration,
      self = this;

  if (isIn) {
    self.el.style.display = 'inline';
    self.el.style.opacity = opacity;
  }

  function func() {
    opacity = isIn ? opacity + gap : opacity - gap;
    self.el.style.opacity = opacity;

    if (opacity <= 0) self.el.style.display = 'none';
    if (opacity <= 0 || opacity >= 1) window.clearInterval(fading);
  }

  var fading = window.setInterval(func, interval);
};

/*
 * Pop Up
 */
function showPopUp(content, footerContent) {

  if (content !== '') {
    qs('#popup .box-content').innerHTML(content);
  }

  if (footerContent !== '') {
    qs('#popup .box-footer').innerHTML(footerContent);
  } else {
    qs('#popup .box-footer').remove();
  }

  qs('#popup').style.display = '';
  _('#popup').fade('out', 0);
  _('#popup').fade('in', 500);

  qs('#popup .close-button').addEventListener('click', function (e) {

    e.preventDefault();

    _('#popup').fade('out', 0);
  });
}

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
function getClosest(elem, selector) {

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
  }

  // Get closest match
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }

  return null;
}

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _wq = void 0;
var URL = "https://fast.wistia.com/assets/external/E-v1.js";

var embedScripts = function embedScripts() {
  var script = document.createElement("script");
  script.src = URL;
  script.async = true;

  document.body.appendChild(script);
};

var load = exports.load = function load(cb) {
  if (window._wq !== undefined) return cb(window._wq);

  window._wq = [];
  embedScripts();
};

var embedVideo = exports.embedVideo = function embedVideo(handle, cb) {
  window._wq.push({ id: handle, onReady: cb });
};

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNodeList;
function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== "undefined"; 
}

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasAttr;
function hasAttr(el, attr) {
  return el.hasAttribute(attr);
}

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(93);

__webpack_require__(110);

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functionsVanilla = __webpack_require__(1);

var functions = _interopRequireWildcard(_functionsVanilla);

var _analyticsHandlers = __webpack_require__(3);

var _analyticsHandlers2 = _interopRequireDefault(_analyticsHandlers);

var _analytics = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * Throttling function for scrolling events
 */
function throttle(delay, callback) {
  var previousCall = new Date().getTime();
  return function () {
    var time = new Date().getTime();

    if (time - previousCall >= delay) {
      previousCall = time;
      callback.apply(null, arguments);
    }
  };
}

var trackEvent = function trackEvent(event, payload) {
  payload ? analytics.track(event, payload) : analytics.track(event);
};

var getDataHandlerAttr = function getDataHandlerAttr(node) {
  return node.getAttribute('data-analytics-handler');
};

var getEventData = function getEventData(handler, currentPage, node) {
  var eventData = _analyticsHandlers2.default[handler];

  if (!eventData) {
    console.warn('No analytics handler for: ' + handler);
    return false;
  }

  return _analyticsHandlers2.default[handler](currentPage, node);
};

var attachClickEvent = function attachClickEvent(node, eventName, payload) {
  node.addEventListener('click', function (e) {
    trackEvent(eventName, payload);
  });
};

var attachHoverEvent = function attachHoverEvent(node, eventName, payload) {
  node.addEventListener('mouseenter', function (e) {
    e.stopPropagation();
    trackEvent(eventName, payload);
  });
};

var attachHoverNoClickEvent = function attachHoverNoClickEvent(node, eventName, payload) {
  node.addEventListener('mouseenter', function (e) {
    var clicked = false;
    var called = false;

    node.addEventListener('mousedown', function () {
      clicked = true;
    });

    node.addEventListener('mouseout', function (e) {
      if (!clicked && !called) {
        trackEvent(eventName, payload);
        called = true;
      }

      node.removeEventListener('mousedown');
      node.removeEventListener('mouseout');
    });
  });
};

var checkEventOptions = function checkEventOptions(pageName, options) {
  var lang = _analytics.convertLanguage[pageName];
  if (!(options && options.ignoreView)) {
    if (lang) {
      trackEvent('splash.regional.view', { locale: lang });
    } else {
      trackEvent('splash.' + pageName + '.view');
    }
  }
  if (options && options.trackScrolling) {
    addScrollEvent(pageName);
  }
};

var addCampaignTracking = function addCampaignTracking() {
  var campaignUtils = {};

  /*
   * Turn query param string into a hash.
   */
  campaignUtils.deparam = function deparam(str) {
    var pairs, hash;
    // remove the '?'
    if (!str || !str.length) {
      return;
    }

    if (str[0] === '?') {
      str = str.slice(1);
    }
    str = decodeURIComponent(str);

    // this gives back something of the form: [[key1, val1], [key2, val2]]
    pairs = str.split("&").map(function (item) {
      return item.split("=");
    });

    hash = {};
    pairs.forEach(function (pair) {
      hash[pair[0]] = pair[1];
    });

    return hash;
  };

  campaignUtils.extractCampaignAttributionData = function extractCampaignAttributionData(queryParams) {
    var campaignFields, campaignData;
    campaignFields = ["utm_source", "utm_medium", "utm_term", "utm_content", "utm_campaign"];
    campaignData = {};

    queryParams && campaignFields.forEach(function (field) {
      if (queryParams[field]) {
        campaignData[field] = queryParams[field];
      }
    });

    return campaignData;
  };

  var query, campaignData;
  query = campaignUtils.deparam(window.location.search);
  campaignData = campaignUtils.extractCampaignAttributionData(query);
  if (campaignData && campaignData.utm_campaign) {
    analytics.track('campaign', campaignData);
  }
};

var addScrollEvent = function addScrollEvent(pageName) {
  var sections = [].slice.call(document.querySelectorAll('section'));

  window.onscroll = throttle(300, function () {
    sections.forEach(function (thisSection, index, sectionArray) {
      var eventProperties = {};

      if (window.pageYOffset >= thisSection.offsetTop) {
        eventProperties.page_element = thisSection.getAttribute('data-scroll-element');
        trackEvent('splash.' + pageName + '.scroll', eventProperties);
        sections.splice(index, 1);
      }
    });
  });
};

var getAnalyticsHandlers = function getAnalyticsHandlers(node) {
  return getDataHandlerAttr(node).split(',');
};

var attachAnalyticsToDOM = function attachAnalyticsToDOM(currentPage, options) {
  document.querySelectorAll('[data-analytics-handler]').forEach(function (node) {
    var handlers = getAnalyticsHandlers(node);

    handlers.forEach(function (handler) {
      var eventData = getEventData(handler, currentPage, node);

      if (!eventData) {
        return;
      }

      var eventType = eventData.eventType,
          eventName = eventData.eventName,
          payload = eventData.payload;


      if (eventType === 'click') {
        attachClickEvent(node, eventName, payload);
      }

      if (eventType === 'hover') {
        attachHoverEvent(node, eventName, payload);
      }

      if (eventType === 'hover-no-click') {
        attachHoverNoClickEvent(node, eventName, payload);
      }
    });
  });
};

var plangridTrackEvents = function plangridTrackEvents(pageName, options) {
  checkEventOptions(pageName, options);
  addCampaignTracking();
  attachAnalyticsToDOM(pageName);
};

exports.default = plangridTrackEvents;

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNodeList;
function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== "undefined"; 
}

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return passiveOption; });
// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      supportsPassive = true;
    }
  });
  window.addEventListener("test", null, opts);
} catch (e) {}
var passiveOption = supportsPassive ? { passive: true } : false;

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isNodeList__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = removeAttrs;


function removeAttrs(els, attrs) {
  els = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isNodeList__["a" /* isNodeList */])(els) || els instanceof Array) ? els : [els];
  attrs = (attrs instanceof Array) ? attrs : [attrs];

  var attrLength = attrs.length;
  for (var i = els.length; i--;) {
    for (var j = attrLength; j--;) {
      els[i].removeAttribute(attrs[j]);
    }
  }
}

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isNodeList__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = setAttrs;


function setAttrs(els, attrs) {
  els = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isNodeList__["a" /* isNodeList */])(els) || els instanceof Array) ? els : [els];
  if (Object.prototype.toString.call(attrs) !== '[object Object]') { return; }

  for (var i = els.length; i--;) {
    for(var key in attrs) {
      els[i].setAttribute(key, attrs[key]);
    }
  }
}

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getHeaderFooterClickEventName = __webpack_require__(4);

var _getHeaderFooterClickEventName2 = _interopRequireDefault(_getHeaderFooterClickEventName);

var _analytics = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  "header-logo-click": function headerLogoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.plangrid.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-link-click": function headerLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _getHeaderFooterClickEventName2.default)(node, 'header'),
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-globe-click": function headerGlobeClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.header.click',
      payload: {
        'locale': (0, _analytics.getRegionalHeaderLinkName)(node)
      }
    };
  },
  "regional-header-link-click": function regionalHeaderLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.header.click',
      payload: {
        'link': (0, _analytics.getRegionalHeaderLinkName)(node),
        'locale': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "regional-cta-click": function regionalCtaClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.regional.signup.submit',
      payload: {
        'locale': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-phone-click": function headerPhoneClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.phone.click',
      payload: {
        'current_page': currentPage
      }
    };
  },
  "header-login-click": function headerLoginClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.login.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-signup-click": function headerSignupClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.signup.click',
      payload: {
        'current_page': (0, _analytics.getCurrentPage)(currentPage)
      }
    };
  },
  "header-mobile-expand-click": function headerMobileExpandClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.header.expand.click',
      payload: {
        'current_page': currentPage
      }
    };
  },
  "footer-link-click": function footerLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _getHeaderFooterClickEventName2.default)(node, 'footer'),
      payload: {
        'current_page': currentPage
      }
    };
  },
  "footer-ios-download-click": function footerIosDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'ios'
      }
    };
  },
  "footer-android-download-click": function footerAndroidDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'android'
      }
    };
  },
  "footer-windows-download-click": function footerWindowsDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'current_page': currentPage,
        'button_place': 'footer',
        platform: 'windows'
      }
    };
  },
  "home-product-explore-click": function homeProductExploreClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.product_explore.click'
    };
  },
  "home-video-click": function homeVideoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.video.click'
    };
  },
  "home-video-hover-no-click": function homeVideoHoverNoClick(currentPage) {
    return {
      eventType: 'hover-no-click',
      eventName: 'splash.home.video.hover'
    };
  },
  "home-testimonials-click": function homeTestimonialsClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.testimonials.click'
    };
  },
  "home-mainCTA-ios-download-click": function homeMainCTAIosDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'ios'
      }
    };
  },
  "home-mainCTA-windows-download-click": function homeMainCTAWindowsDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'windows'
      }
    };
  },
  "home-mainCTA-android-download-click": function homeMainCTAAndroidDownloadClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.home.download.click',
      payload: {
        'button_place': 'main_CTA',
        'platform': 'android'
      }
    };
  },
  "home-secondaryCTA-signup-click": function homeSecondaryCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.signup.submit',
      payload: {
        'button_place': 'secondary_CTA'
      }
    };
  },
  "home-mainCTA-signup-click": function homeMainCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.signup.submit',
      payload: {
        'button_place': 'main_CTA'
      }
    };
  },
  "home-projects-category-click": function homeProjectsCategoryClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.home.projects_category.click',
      payload: {
        'context': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "home-projects-category-hover": function homeProjectsCategoryHover(currentPage, node) {
    return {
      eventType: 'hover',
      eventName: 'splash.home.projects_category.hover',
      payload: {
        'context': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "home-projects-explore-click": function homeProjectsExploreClick() {
    return {
      eventType: 'click',
      eventName: 'splash.home.projects_explore.click'
    };
  },
  "product-mainCTA-signup-click": function productMainCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'main_cta'
      }
    };
  },
  "product-secondaryCTA-signup-click": function productSecondaryCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'secondary_cta'
      }
    };
  },
  "product-bottomCTA-signup-click": function productBottomCTASignupClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.signup.click',
      payload: {
        'button_place': 'bottom_cta'
      }
    };
  },
  "product-ipad-arrow-click": function productIpadArrowClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.ipad_features.click'
    };
  },
  "product-feature-text-click": function productFeatureTextClick() {
    return {
      eventType: 'click',
      eventName: 'splash.product.text_features.click'
    };
  },
  "product-download-click": function productDownloadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _analytics.downloadEventName)(currentPage),
      payload: (0, _analytics.getDownloadPayload)(node, currentPage)
    };
  },
  "feature-page-demo-click": function featurePageDemoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.demo.click'
    };
  },
  "feature-page-video-click": function featurePageVideoClick(currentPage) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.video.click'
    };
  },
  "feature-link-click": function featureLinkClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.feature.click',
      payload: {
        'page-click': (0, _analytics.transformNodeText)(node.text)
      }
    };
  },
  "header-contact-click": function headerContactClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.contact_sales.click'
    };
  },
  "sidenav-filter-click": function sidenavFilterClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.filter.click',
      payload: {
        type: (0, _analytics.transformNodeText)(node.getAttribute('data-link-category'))
      }
    };
  },
  "sidenav-mobile-click": function sidenavMobileClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.' + currentPage + '.dropdown.click'
    };
  },
  "partner-sidenav-become-a-partner-click": function partnerSidenavBecomeAPartnerClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.resources.partners.contact.click',
      payload: {
        context: 'sidenav'
      }
    };
  },
  "partner-sidenav-explore-our-api-click": function partnerSidenavExploreOurApiClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.resources.partners.doc.click',
      payload: {
        context: 'sidenav'
      }
    };
  },
  "projects-project-click": function projectsProjectClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.project.click',
      payload: {
        company_name: (0, _analytics.getCompanyFromNode)(node),
        project_name: (0, _analytics.getHref)(node)
      }
    };
  },
  "case-study-quote-click": function caseStudyQuoteClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.quote.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "case-study-download-click": function caseStudyDownloadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.download.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "case-study-signup-click": function caseStudySignupClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.projects.signup.click',
      payload: {
        project_name: currentPage
      }
    };
  },
  "video-feature-click": function videoFeatureClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: (0, _analytics.featureExploreEventName)(currentPage),
      payload: (0, _analytics.getVideoPayload)(node, currentPage)
    };
  },
  "events-filter-click": function eventsFilterClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.events.filter.click',
      payload: {
        'filter': (0, _analytics.transformNodeText)(node.getAttribute('value'))
      }
    };
  },
  "userGroups-lead-click": function userGroupsLeadClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.lead.click'
    };
  },
  "userGroups-join-click": function userGroupsJoinClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.join.click'
    };
  },
  "userGroups-faq-click": function userGroupsFaqClick(currentPage, node) {
    return {
      eventType: 'click',
      eventName: 'splash.user_groups.faq.click'
    };
  }
};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    transformNodeText = _require.transformNodeText;

module.exports = function (node, option) {
  if (!(option === 'header' || option === 'footer')) {
    throw "Invalid option";
  }
  return 'splash.' + option + '.' + transformNodeText(node.text) + '.click';
};

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isNodeList__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = append;


function append(els, data) {
  var els_new = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isNodeList__["a" /* isNodeList */])(els)) ? els : [els], i;

  if (typeof data.nodeType !== "undefined" && data.nodeType === 1) {
    for (i = els_new.length; i--;) {
      els_new[i].appendChild(data);
    }
  } else if (typeof data === "string") {
    for (i = els_new.length; i--;) {
      els_new[i].insertAdjacentHTML("beforeend", data);
    }
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isNodeList__["a" /* isNodeList */])(data)) {
    var fragment = document.createDocumentFragment();
    for (i = data.length; i--;) {
      fragment.insertBefore(data[i], fragment.firstChild);
    }
    for (var j = els_new.length; j--;) {
      els_new[j].appendChild(fragment);
    }
  }
}

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extend;
function extend() {
  var obj, name, copy,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length;

  for (; i < length; i++) {
    if ((obj = arguments[i]) !== null) {
      for (name in obj) {
        copy = obj[name];

        if (target === copy) {
          continue;
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSupportedProp;
function getSupportedProp(proparray){
  var root = document.documentElement;
  for (var i=0; i<proparray.length; i++){
    if (proparray[i] in root.style){
      return proparray[i];
    }
  }
}

// var getTD = gn.getSupportedProp(['transitionDuration', 'WebkitTransitionDuration', 'MozTransitionDuration', 'OTransitionDuration']),
// getTransform = gn.getSupportedProp(['transform', 'WebkitTransform', 'MozTransform', 'OTransform']);

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = indexOf;
function indexOf(array, item) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === item) { return i; }
  }
  return -1;
}

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isNodeList__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = unwrap;


function unwrap(els) {
  var elsNew = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isNodeList__["a" /* isNodeList */])(els)) ? els : [els];
  for (var i = elsNew.length; i--;) {
    var el = elsNew[i];

    // get the element's parent node
    var parent = el.parentNode;
    
    // move all children out of the element
    while (el.firstChild) { 
      parent.insertBefore(el.firstChild, el); 
    }
    
    // remove the empty element
    parent.removeChild(el);
  }
}

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isNodeList__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = wrap;


function wrap(els, obj) {
  var elsNew = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isNodeList__["a" /* isNodeList */])(els)) ? els : [els];
  // Loops backwards to prevent having to clone the wrapper on the
  // first element (see `wrapper` below).
  for (var i = elsNew.length; i--;) {
    var wrapper = (i > 0) ? obj.cloneNode(true) : obj,
      el = elsNew[i];

    // Cache the current parent and sibling.
    var parent = el.parentNode,
      sibling = el.nextSibling;

    // Wrap the element (is automatically removed from its current parent).
    wrapper.appendChild(el);

    // If the element had a sibling, insert the wrapper before
    // the sibling to maintain the HTML structure; otherwise, just
    // append it to the parent.
    if (sibling) {
      parent.insertBefore(wrapper, sibling);
    } else {
      parent.appendChild(wrapper);
    }
  }
}

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

// ChildNode.remove
(function () {
  "use strict";

  if(!("remove" in Element.prototype)){
    Element.prototype.remove = function(){
      if(this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
})();


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// Adapted from https://gist.github.com/paulirish/1579671 which derived from 
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller.
// Fixes from Paul Irish, Tino Zijdel, Andrew Mao, Klemen Slavič, Darius Bacon

// MIT license

if (!Date.now)
    Date.now = function() { return new Date().getTime(); };

(function() {
    'use strict';
    
    var vendors = ['webkit', 'moz'];
    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
        var vp = vendors[i];
        window.requestAnimationFrame = window[vp+'RequestAnimationFrame'];
        window.cancelAnimationFrame = (window[vp+'CancelAnimationFrame']
                                   || window[vp+'CancelRequestAnimationFrame']);
    }
    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) // iOS6 is buggy
        || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
        var lastTime = 0;
        window.requestAnimationFrame = function(callback) {
            var now = Date.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function() { callback(lastTime = nextTime); },
                              nextTime - now);
        };
        window.cancelAnimationFrame = clearTimeout;
    }
}());


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

/** DOMTokenList polyfill */
(function(){
	"use strict";
	
	/*<*/
	var UNDEF,
	WIN   = window,
	DOC   = document,
	OBJ   = Object,
	NULL  = null,
	TRUE  = true,
	FALSE = false,
	/*>*/
	
	/** Munge the hell out of our string literals. Saves a tonne of space after compression. */
	SPACE           = " ",
	ELEMENT         = "Element",
	CREATE_ELEMENT  = "create"+ELEMENT,
	DOM_TOKEN_LIST  = "DOMTokenList",
	DEFINE_GETTER   = "__defineGetter__",
	DEFINE_PROPERTY = "defineProperty",
	CLASS_          = "class",
	LIST            = "List",
	CLASS_LIST      = CLASS_+LIST,
	REL             = "rel",
	REL_LIST        = REL+LIST,
	DIV             = "div",
	LENGTH          = "length",
	CONTAINS        = "contains",
	APPLY           = "apply",
	HTML_           = "HTML",
	METHODS         = ("item "+CONTAINS+" add remove toggle toString toLocaleString").split(SPACE),
	ADD             = METHODS[2],
	REMOVE          = METHODS[3],
	TOGGLE          = METHODS[4],
	PROTOTYPE       = "prototype",
	
	
	
	/** Ascertain browser support for Object.defineProperty */
	dpSupport       = DEFINE_PROPERTY in OBJ || DEFINE_GETTER in OBJ[ PROTOTYPE ] || NULL,
	
	
	/** Wrapper for Object.defineProperty that falls back to using the legacy __defineGetter__ method if available. */
	defineGetter    = function(object, name, fn, configurable){
		if(OBJ[ DEFINE_PROPERTY ])
			OBJ[ DEFINE_PROPERTY ](object, name, {
				configurable: FALSE === dpSupport ? TRUE : !!configurable,
				get:          fn
			});
		
		else object[ DEFINE_GETTER ](name, fn);
	},
	
	
	
	
	/** DOMTokenList interface replacement */
	DOMTokenList = function(el, prop){
		var THIS    = this,
		
		/** Private variables */
		tokens      = [],
		tokenMap    = {},
		length      = 0,
		maxLength   = 0,
		
		
		reindex     = function(){
			
			/** Define getter functions for array-like access to the tokenList's contents. */
			if(length >= maxLength)
				for(; maxLength < length; ++maxLength) (function(i){
					
					defineGetter(THIS, i, function(){
						preop();
						return tokens[i];
					}, FALSE);
					
				})(maxLength);
		},
		
		
		
		/** Helper function called at the start of each class method. Internal use only. */
		preop = function(){
			var error, i,
			args    = arguments,
			rSpace  = /\s+/;
			
			/** Validate the token/s passed to an instance method, if any. */
			if(args[ LENGTH ])
				for(i = 0; i < args[ LENGTH ]; ++i)
					if(rSpace.test(args[i])){
						error       = new SyntaxError('String "' + args[i] + '" ' + CONTAINS + ' an invalid character');
						error.code  = 5;
						error.name  = "InvalidCharacterError";
						throw error;
					}
			
			
			/** Split the new value apart by whitespace*/
			tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
			
			/** Avoid treating blank strings as single-item token lists */
			if("" === tokens[0]) tokens = [];
			
			/** Repopulate the internal token lists */
			tokenMap = {};
			for(i = 0; i < tokens[ LENGTH ]; ++i)
				tokenMap[tokens[i]] = TRUE;
			length = tokens[ LENGTH ];
			reindex();
		};
		
		
		
		/** Populate our internal token list if the targeted attribute of the subject element isn't empty. */
		preop();
		
		
		
		/** Return the number of tokens in the underlying string. Read-only. */
		defineGetter(THIS, LENGTH, function(){
			preop();
			return length;
		});
		
		
		/** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */
		THIS[ METHODS[6] /** toLocaleString */ ] =
		THIS[ METHODS[5] /** toString       */ ] = function(){
			preop();
			return tokens.join(SPACE);
		};
		
		
		
		/** Return an item in the list by its index (or undefined if the number is greater than or equal to the length of the list) */
		THIS.item = function(idx){
			preop();
			return tokens[idx];
		};
		
		
		/** Return TRUE if the underlying string contains `token`; otherwise, FALSE. */
		THIS[ CONTAINS ] = function(token){
			preop();
			return !!tokenMap[token];
		};
		
		
		
		/** Add one or more tokens to the underlying string. */
		THIS[ADD] = function(){
			preop[APPLY](THIS, args = arguments);

			for(var args, token, i = 0, l = args[ LENGTH ]; i < l; ++i){
				token = args[i];
				if(!tokenMap[token]){
					tokens.push(token);
					tokenMap[token] = TRUE;
				}
			}
			
			/** Update the targeted attribute of the attached element if the token list's changed. */
			if(length  !== tokens[ LENGTH ]){
				length   = tokens[ LENGTH ] >>> 0;
				el[prop] = tokens.join(SPACE);
				reindex();
			}
		};
		
		
		
		/** Remove one or more tokens from the underlying string. */
		THIS[ REMOVE ] = function(){
			preop[APPLY](THIS, args = arguments);
			
			/** Build a hash of token names to compare against when recollecting our token list. */
			for(var args, ignore = {}, i = 0, t = []; i < args[ LENGTH ]; ++i){
				ignore[args[i]] = TRUE;
				delete tokenMap[args[i]];
			}
			
			/** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */
			for(i = 0; i < tokens[ LENGTH ]; ++i)
				if(!ignore[tokens[i]]) t.push(tokens[i]);
			
			tokens   = t;
			length   = t[ LENGTH ] >>> 0;
			
			/** Update the targeted attribute of the attached element. */
			el[prop] = tokens.join(SPACE);
			reindex();
		};
		
		
		
		/** Add or remove a token depending on whether it's already contained within the token list. */
		THIS[TOGGLE] = function(token, force){
			preop[APPLY](THIS, [token]);
			
			/** Token state's being forced. */
			if(UNDEF !== force){
				if(force) { THIS[ADD](token);     return TRUE;  }
				else      { THIS[REMOVE](token);  return FALSE; }
			}
			
			/** Token already exists in tokenList. Remove it, and return FALSE. */
			if(tokenMap[token]){
				THIS[ REMOVE ](token);
				return FALSE;
			}
			
			/** Otherwise, add the token and return TRUE. */
			THIS[ADD](token);
			return TRUE;
		};
		
		
		/** Mark our newly-assigned methods as non-enumerable. */
		(function(o, defineProperty){
			if(defineProperty)
				for(var i = 0; i < 7; ++i)
					defineProperty(o, METHODS[i], {enumerable: FALSE});
		}(THIS, OBJ[ DEFINE_PROPERTY ]));
		
		return THIS;
	},
	
	
	
	/** Polyfills a property with a DOMTokenList */
	addProp = function(o, name, attr){
		
		defineGetter(o[PROTOTYPE], name, function(){
			var tokenList,
			THIS = this,
			
			/** Prevent this from firing twice for some reason. What the hell, IE. */
			gibberishProperty           = DEFINE_GETTER + DEFINE_PROPERTY + name;
			if(THIS[gibberishProperty]) return tokenList;
			THIS[gibberishProperty]     = TRUE;
			
			
			/**
			 * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
			 *
			 * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
			 * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
			 * element instead, this would conflict with element types which use indexed properties (such as forms and
			 * select lists).
			 */
			if(FALSE === dpSupport){
				
				var visage,
				mirror      = addProp.mirror = addProp.mirror || DOC[ CREATE_ELEMENT ](DIV),
				reflections = mirror.childNodes,
				
				/** Iterator variables */
				l = reflections[ LENGTH ],
				i = 0;
				
				for(; i < l; ++i)
					if(reflections[i]._R === THIS){
						visage = reflections[i];
						break;
					}
				
				/** Couldn't find an element's reflection inside the mirror. Materialise one. */
				visage || (visage = mirror.appendChild(DOC[ CREATE_ELEMENT ](DIV)));
				
				tokenList = DOMTokenList.call(visage, THIS, attr);
			}
			
			else tokenList = new DOMTokenList(THIS, attr);
			
			
			defineGetter(THIS, name, function(){ return tokenList; });
			delete THIS[gibberishProperty];
			
			return tokenList;
		}, TRUE);
	},

	/** Variables used for patching native methods that're partially implemented (IE doesn't support adding/removing multiple tokens, for instance). */
	testList,
	nativeAdd,
	nativeRemove;
	
	
	
	
	/** No discernible DOMTokenList support whatsoever. Time to remedy that. */
	if(!WIN[ DOM_TOKEN_LIST ]){
		
		/** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */
		if(dpSupport)
			try{ defineGetter({}, "support"); }
			catch(e){ dpSupport = FALSE; }
		
		
		DOMTokenList.polyfill   = TRUE;
		WIN[ DOM_TOKEN_LIST ]   = DOMTokenList;
		
		addProp( WIN[ ELEMENT ], CLASS_LIST, CLASS_ + "Name");      /* Element.classList */
		addProp( WIN[ HTML_+ "Link"   + ELEMENT ], REL_LIST, REL);  /* HTMLLinkElement.relList */
		addProp( WIN[ HTML_+ "Anchor" + ELEMENT ], REL_LIST, REL);  /* HTMLAnchorElement.relList */
		addProp( WIN[ HTML_+ "Area"   + ELEMENT ], REL_LIST, REL);  /* HTMLAreaElement.relList */
	}
	
	
	/**
	 * Possible support, but let's check for bugs.
	 *
	 * Where arbitrary values are needed for performing a test, previous variables
	 * are recycled to save space in the minified file.
	 */
	else{
		testList = DOC[ CREATE_ELEMENT ](DIV)[CLASS_LIST];
		
		/** We'll replace a "string constant" to hold a reference to DOMTokenList.prototype (filesize optimisation, yaddah-yaddah...) */
		PROTOTYPE = WIN[DOM_TOKEN_LIST][PROTOTYPE];
		
		
		/** Check if we can pass multiple arguments to add/remove. To save space, we'll just recycle a previous array of strings. */
		testList[ADD][APPLY](testList, METHODS);
		if(2 > testList[LENGTH]){
			nativeAdd      = PROTOTYPE[ADD];
			nativeRemove   = PROTOTYPE[REMOVE];
			
			PROTOTYPE[ADD] = function(){
				for(var i = 0, args = arguments; i < args[LENGTH]; ++i)
					nativeAdd.call(this, args[i]);
			};
			
			PROTOTYPE[REMOVE] = function(){
				for(var i = 0, args = arguments; i < args[LENGTH]; ++i)
					nativeRemove.call(this, args[i]);
			};
		}
		
		
		/** Check if the "force" option of .toggle is supported. */
		if(testList[TOGGLE](LIST, FALSE))
			PROTOTYPE[TOGGLE] = function(token, force){
				var THIS = this;
				THIS[(force = UNDEF === force ? !THIS[CONTAINS](token) : force) ? ADD : REMOVE](token);
				return !!force;
			};
	}
}());


/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__passiveOption__ = __webpack_require__(26);
/* harmony export (immutable) */ __webpack_exports__["a"] = addEvents;


function addEvents(el, obj) {
  for (var prop in obj) {
    var option = (prop === 'touchstart' || prop === 'touchmove') ? __WEBPACK_IMPORTED_MODULE_0__passiveOption__["a" /* passiveOption */] : false;
    el.addEventListener(prop, obj[prop], option);
  }
}

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Events;
function Events() {
  return {
    topics: {},
    on: function (eventName, fn) {
      this.topics[eventName] = this.topics[eventName] || [];
      this.topics[eventName].push(fn);
    },
    off: function(eventName, fn) {
      if (this.topics[eventName]) {
        for (var i = 0; i < this.topics[eventName].length; i++) {
          if (this.topics[eventName][i] === fn) {
            this.topics[eventName].splice(i, 1);
            break;
          }
        }
      }
    },
    emit: function (eventName, data) {
      if (this.topics[eventName]) {
        this.topics[eventName].forEach(function(fn) {
          fn(data);
        });
      }
    }
  };
};

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAttr;
function getAttr(el, attr) {
  return el.getAttribute(attr);
}

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSlideId;
function getSlideId() {
  if (window.tnsId === undefined) {
    window.tnsId = 1;
  } else {
    window.tnsId++;
  }
  return 'tns' + window.tnsId;
}

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTouchDirection;
function getTouchDirection(angle, range) {
  if ( Math.abs(90 - Math.abs(angle)) >= (90 - range) ) {
    return 'horizontal';
  } else if ( Math.abs(90 - Math.abs(angle)) <= range ) {
    return 'vertical';
  } else {
    return false;
  }
}

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasAttr__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setAttrs__ = __webpack_require__(28);
/* harmony export (immutable) */ __webpack_exports__["a"] = hideElement;



function hideElement(el) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hasAttr__["a" /* hasAttr */])(el, 'hidden')) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__setAttrs__["a" /* setAttrs */])(el, {'hidden': ''});
  }
}

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imageLoaded;
// check if an image is loaded
// 1. See if "naturalWidth" and "naturalHeight" properties are available.
// 2. See if "complete" property is available.

function imageLoaded(img) {
  if (typeof img.complete === 'boolean') {
    return img.complete;
  } else if (typeof img.naturalWidth === 'number') {
    return img.naturalWidth !== 0;
  }
}

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jsTransform;
function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
  var tick = Math.min(duration, 10),
      from = Number(element.style[attr].slice(prefix.length, - (postfix.length + 2))),
      positionTick = (to - from) / duration * tick,
      running;

  setTimeout(moveElement, tick);
  function moveElement() {
    duration -= tick;
    from += positionTick;
    element.style[attr] = prefix + from + 'px' + postfix;
    if (duration > 0) { 
      setTimeout(moveElement, tick); 
    } else {
      callback();
    }
  }
}

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__passiveOption__ = __webpack_require__(26);
/* harmony export (immutable) */ __webpack_exports__["a"] = removeEvents;


function removeEvents(el, obj) {
  for (var prop in obj) {
    var option = (prop === 'touchstart' || prop === 'touchmove') ? __WEBPACK_IMPORTED_MODULE_0__passiveOption__["a" /* passiveOption */] : false;
    el.removeEventListener(prop, obj[prop], option);
  }
}

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeEventsByClone;
function removeEventsByClone(el) {
  var elClone = el.cloneNode(true), parent = el.parentNode;
  parent.insertBefore(elClone, el);
  el.remove();
  el = null;
}

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasAttr__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__removeAttrs__ = __webpack_require__(27);
/* harmony export (immutable) */ __webpack_exports__["a"] = showElement;



function showElement(el) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hasAttr__["a" /* hasAttr */])(el, 'hidden')) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__removeAttrs__["a" /* removeAttrs */])(el, 'hidden');
  }
}

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toDegree;
function toDegree (y, x) {
  return Math.atan2(y, x) * (180 / Math.PI);
}

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = whichProperty;
function whichProperty(obj){
  var t, el = document.createElement('fakeelement');
  for(t in obj){
    if( el.style[t] !== undefined ){
      return [t, obj[t][0], obj[t][1]];
    }
  }

  return false; // explicit for ie9-
}

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bower_components_go_native_src_utilities_childNode_remove__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bower_components_go_native_src_utilities_childNode_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bower_components_go_native_src_utilities_childNode_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bower_components_go_native_src_vendors_requestAnimationFrame__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bower_components_go_native_src_vendors_requestAnimationFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bower_components_go_native_src_vendors_requestAnimationFrame__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bower_components_go_native_src_vendors_token_list__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bower_components_go_native_src_vendors_token_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bower_components_go_native_src_vendors_token_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bower_components_go_native_src_gn_extend__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bower_components_go_native_src_gn_indexOf__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bower_components_go_native_src_gn_getSupportedProp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bower_components_go_native_src_gn_append__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bower_components_go_native_src_gn_wrap__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bower_components_go_native_src_gn_unwrap__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_getSlideId__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_toDegree__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_getTouchDirection__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_hasAttr__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_getAttr__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_removeEventsByClone__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_hideElement__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_showElement__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_imageLoaded__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_whichProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_removeEvents__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_events__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_jsTransform__ = __webpack_require__(69);
/* harmony export (immutable) */ __webpack_exports__["tns"] = tns;
// PRODUCTION

// from go-native











// helper functions

















var TRANSFORM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__bower_components_go_native_src_gn_getSupportedProp__["a" /* getSupportedProp */])([
      'transform', 
      'WebkitTransform', 
      'MozTransform', 
      'msTransform',
      'OTransform'
    ]),
    transitions = {
      'transitionDuration': ['transitionDelay', 'transitionend'],
      'WebkitTransitionDuration': ['WebkitTransitionDelay', 'webkitTransitionEnd'],
      'MozTransitionDuration': ['MozTransitionDelay', 'transitionend'],
      'OTransitionDuration': ['OTransitionDelay', 'oTransitionEnd']
    },
    animations = {
      'animationDuration': ['animationDelay', 'animationend'],
      'WebkitAnimationDuration': ['WebkitAnimationDelay', 'webkitAnimationEnd'],
      'MozAnimationDuration': ['MozAnimationDelay', 'animationend'],
      'OAnimationDuration': ['OAnimationDelay', 'oAnimationEnd']
    },
    TRANSITIONDURATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_whichProperty__["a" /* whichProperty */])(transitions)[0],
    TRANSITIONDELAY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_whichProperty__["a" /* whichProperty */])(transitions)[1],
    TRANSITIONEND = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_whichProperty__["a" /* whichProperty */])(transitions)[2],
    ANIMATIONDURATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_whichProperty__["a" /* whichProperty */])(animations)[0],
    ANIMATIONDELAY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_whichProperty__["a" /* whichProperty */])(animations)[1],
    ANIMATIONEND = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_whichProperty__["a" /* whichProperty */])(animations)[2],
    KEY = {
      ENTER: 13,
      SPACE: 32,
      PAGEUP: 33,
      PAGEDOWN: 34,
      END: 35,
      HOME: 36,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40
    };
// console.log(
//   TRANSITIONDURATION,
//   TRANSITIONDELAY,
//   TRANSITIONEND,
//   ANIMATIONDURATION,
//   ANIMATIONDELAY,
//   ANIMATIONEND
//   );

function tns(options) {
  options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bower_components_go_native_src_gn_extend__["a" /* extend */])({
    container: document.querySelector('.slider'),
    mode: 'carousel',
    axis: 'horizontal',
    items: 1,
    gutter: 0,
    edgePadding: 0,
    fixedWidth: false,
    slideBy: 1,
    controls: true,
    controlsText: ['prev', 'next'],
    controlsContainer: false,
    nav: true,
    navContainer: false,
    arrowKeys: false,
    speed: 300,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayDirection: 'forward',
    autoplayText: ['start', 'stop'],
    autoplayHoverPause: false,
    autoplayButton: false,
    autoplayResetOnVisibility: true,
    animateIn: 'tns-fadeIn',
    animateOut: 'tns-fadeOut',
    animateNormal: 'tns-normal',
    animateDelay: false,
    loop: true,
    autoHeight: false,
    responsive: false,
    lazyload: false,
    touch: true,
    mouseDrag: false,
    rewind: false,
    nested: false,
    onInit: false
  }, options || {});
  // make sure slide container exists
  if (typeof options.container !== 'object' || options.container === null) { return; }

  // === define and set variables ===
  var mode = options.mode,
      axis = options.axis,
      wrapper = document.createElement('div'),
      contentWrapper = document.createElement('div'),
      container = options.container,
      slideItems = container.children,
      slideCount = slideItems.length,
      items = options.items,
      slideBy = getSlideBy(),
      nested = options.nested,
      gutter = options.gutter,
      edgePadding = (mode === 'gallery') ? false : options.edgePadding,
      fixedWidth = options.fixedWidth,
      arrowKeys = options.arrowKeys,
      speed = options.speed,
      rewind = options.rewind,
      loop = (mode === 'gallery')? true: (options.rewind)? false : options.loop,
      autoHeight = (mode === 'gallery') ? true : options.autoHeight,
      responsive = (fixedWidth) ? false : options.responsive,
      lazyload = options.lazyload,
      slideId = container.id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_getSlideId__["a" /* getSlideId */])(),
      slideWidth = (fixedWidth)? fixedWidth + gutter : 0,
      slideEdges, // collection of slide edges
      slideItemsOut = [],
      cloneCount = (loop) ? slideCount * 2 : (edgePadding) ? 1 : 0,
      slideCountNew = (mode === 'gallery') ? slideCount + cloneCount : slideCount + cloneCount * 2,
      hasRightDeadZone = (fixedWidth && !loop && !edgePadding)? true : false,
      checkIndexBeforeTransform = (mode === 'gallery' || !loop)? true : false,
      // transform
      transformDir = (axis === 'horizontal')? 'X' : 'Y',
      transformAttrLegacy = (axis === 'horizontal')? 'left' : 'top', 
      transformAttr = transformAttrLegacy,
      transformType = 'translate',
      transformPrefix = '',
      transformPostfix = '',
      // controls
      controls = options.controls,
      controlsText = options.controlsText,
      controlsContainer = (!options.controlsContainer) ? false : options.controlsContainer,
      prevButton,
      nextButton,
      // nav
      nav = options.nav,
      navContainer = options.navContainer || false,
      navItems,
      navCountVisible,
      navCountVisibleCached = slideCount,
      navClicked = -1,
      navCurrent = 0,
      navCurrentCached = 0,
      // index
      index = (mode === 'gallery') ? 0 : cloneCount,
      indexCached = index,
      indexAdjust = (edgePadding) ? 1 : 0,
      indexMin = indexAdjust,
      indexMax,
      vw,
      // autoplay
      autoplay = options.autoplay,
      autoplayTimeout = options.autoplayTimeout,
      autoplayDirection = (options.autoplayDirection === 'forward') ? 1 : -1,
      autoplayText = options.autoplayText,
      autoplayHoverPause = options.autoplayHoverPause,
      autoplayTimer,
      autoplayButton = options.autoplayButton,
      animating = false,
      autoplayHoverStopped = false,
      autoplayHtmlString = '<span hidden>Stop Animation</span>',
      autoplayResetOnVisibility = options.autoplayResetOnVisibility,
      autoplayResetVisibilityState = false,
      // touch
      touch = options.touch,
      startX = null,
      startY = null,
      translateInit,
      disX,
      disY,
      touchedOrDraged,
      //mouse
      mouseDrag = options.mouseDrag,
      mousePressed = false,
      isDragEvent = false,
      // gallery
      animateIn = (ANIMATIONDURATION) ? options.animateIn : 'tns-fadeIn',
      animateOut = (ANIMATIONDURATION) ? options.animateOut : 'tns-fadeOut',
      animateNormal = (ANIMATIONDURATION) ? options.animateNormal : 'tns-normal',
      animateDelay = (ANIMATIONDURATION) ? options.animateDelay : false,
      // resize and scroll
      resizeTimer,
      ticking = false,
      onInit = options.onInit,
      events = new __WEBPACK_IMPORTED_MODULE_23__helpers_events__["a" /* Events */]();

  if (TRANSFORM) {
    transformAttr = TRANSFORM;
    transformPrefix = transformType + transformDir + '(';
    transformPostfix = ')';
  }

  // === COMMON FUNCTIONS === //
  function getSlideBy () {
    return (mode === 'gallery' || options.slideBy === 'page') ? items : options.slideBy;
  }

  var getItems = (function () {
    if (!fixedWidth) {
      return function () {
        var itemsTem = options.items,
            // ww = document.documentElement.clientWidth,
            bpKeys = (typeof responsive === 'object') ? Object.keys(responsive) : false;

        if (bpKeys) {
          bpKeys.forEach(function (key) {
            if (vw >= key) { itemsTem = responsive[key]; }
          });
        }
        return Math.max(1, Math.min(slideCount, itemsTem));
      };

    } else {
      return function () { return Math.max(1, Math.min(slideCount, Math.floor(vw / fixedWidth))); };
    }
  })();

  function getSlideWidth() {
    return (vw + gutter) / items;
  }

  var getVisibleNavCount = (function () {
    if (options.navContainer) {
      return function () { return slideCount; };
    } else {
      return function () { return Math.ceil(slideCount / items); };
    }
  })();

  var getViewWidth = (function () {
    // horizontal carousel: fluid width && edge padding
    //  => inner wrapper view width
    if (axis === 'horizontal' && !fixedWidth && edgePadding) { 
      return function () { return wrapper.clientWidth - (edgePadding + gutter) * 2; };
    // horizontal carousel: fixed width || fluid width but no edge padding
    // vertical carousel
    //  => wrapper view width
    } else {
      return function () { return wrapper.clientWidth; };
    }
  })();

  // compare slide count & items
  // (items) => nav, controls, autoplay
  function checkSlideCount() {
    // a. slide count < items
    //  => disable nav, controls, autoplay
    if (slideCount <= items) { 
      arrowKeys = false;

      var indexTem;
      index = (mode === 'gallery') ? 0 : cloneCount;
      if (index !== indexTem) { events.emit('indexChanged', info()); }

      if (navContainer) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_hideElement__["a" /* hideElement */])(navContainer); }
      if (controlsContainer) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_hideElement__["a" /* hideElement */])(controlsContainer); }
      if (autoplayButton) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__helpers_hideElement__["a" /* hideElement */])(autoplayButton); }
    // b. slide count > items
    //  => enable nav, controls, autoplay
    } else {
      arrowKeys = options.arrowKeys;
      if (nav) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_showElement__["a" /* showElement */])(navContainer); }
      if (controls) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_showElement__["a" /* showElement */])(controlsContainer); }
      if (autoplay) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers_showElement__["a" /* showElement */])(autoplayButton); }
    }
  }

  // === INITIALIZATION FUNCTIONS === //
  function wrapperInit() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(wrapper, {'data-tns-role': 'wrapper'});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(contentWrapper, {'data-tns-role': 'content-wrapper'});
    if (axis === 'vertical') { 
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(contentWrapper, {'data-tns-hidden': 'y'}); 
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(wrapper, {'data-tns-hidden': 'x'}); 
    }

    if (mode === 'carousel') {
      var gap = (fixedWidth && edgePadding) ? getFixedWidthEdgePadding() : (edgePadding) ? edgePadding + gutter : 0;
      contentWrapper.style.cssText = (axis === 'horizontal') ? 'margin: 0 ' + gap + 'px;' : 'padding: ' + gap + 'px 0 ' + edgePadding + 'px; height: ' + getVerticalWrapperHeight() + 'px;'; 
    }
  }

  // vw => items => indexMax, slideWidth, navCountVisible, slideBy
  function getVariables() {
    vw = getViewWidth();
    items = getItems();
    indexMax = slideCountNew - items - indexAdjust;

    if (axis === 'horizontal' && !fixedWidth) { slideWidth = getSlideWidth(); }
    navCountVisible = getVisibleNavCount();
    slideBy = getSlideBy();
  }

  function containerInit() {
    // add id
    if (container.id === '') { container.id = slideId; }
    // add attributes
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(container, {
      'data-tns-role': 'content', 
      'data-tns-mode': mode, 
      'data-tns-axis': axis
    });

    if (axis === 'horizontal') {
      container.style.width = (slideWidth + 1) * slideCountNew + 'px';
    }
  }

  function containerInitStyle() {
    // init width & transform
    if (mode === 'carousel') {
      if (autoHeight) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(container, {'data-tns-hidden': 'y'}); }
      container.style[transformAttr] = transformPrefix + Math.round(-slideEdges[index]) + 'px' + transformPostfix;
    }
  }

  // for IE10
  function msInit() {
    if (navigator.msMaxTouchPoints) {
      wrapper.classList.add('ms-touch');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(wrapper, {'scroll': ie10Scroll});
    }
  }

  function slideItemsInit() {
    for (var x = 0; x < slideCount; x++) {
      var item = slideItems[x];

      // add slide id
      item.id = slideId + '-item' + x;

      // add class
      if (mode === 'gallery' && animateNormal) { item.classList.add(animateNormal); }

      // add aria-hidden attribute
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(item, {'aria-hidden': 'true'});

      // set slide width & gutter
      var gutterPosition = (axis === 'horizontal') ? 'right' : 'bottom', 
          styles = '';
      if (mode === 'carousel') { styles = 'margin-' + gutterPosition + ': ' + gutter + 'px;'; }
      if (axis === 'horizontal') { styles = 'width: ' + (slideWidth - gutter) + 'px; ' + styles; }
      item.style.cssText += styles;
    }

    // clone slides
    if (loop || edgePadding) {
      var fragmentBefore = document.createDocumentFragment(), 
          fragmentAfter = document.createDocumentFragment();

      for (var j = cloneCount; j--;) {
        var num = j%slideCount,
            cloneFirst = slideItems[num].cloneNode(true);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(cloneFirst, 'id');
        fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);

        if (mode === 'carousel') {
          var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(cloneLast, 'id');
          fragmentBefore.appendChild(cloneLast);
        }
      }

      container.insertBefore(fragmentBefore, container.firstChild);
      container.appendChild(fragmentAfter);
      slideItems = container.children;
    }
  }

  function controlsInit() {
    if (controls) {
      if (options.controlsContainer) {
        prevButton = controlsContainer.children[0];
        nextButton = controlsContainer.children[1];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(controlsContainer, {'aria-label': 'Carousel Navigation'});
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(prevButton, {'data-controls' : 'prev'});
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(nextButton, {'data-controls' : 'next'});
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(controlsContainer.children, {
          'aria-controls': slideId,
          'tabindex': '-1',
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__bower_components_go_native_src_gn_append__["a" /* append */])(wrapper, '<div data-tns-role="controls" aria-label="Carousel Navigation"><button data-controls="prev" tabindex="-1" aria-controls="' + slideId +'" type="button">' + controlsText[0] + '</button><button data-controls="next" tabindex="0" aria-controls="' + slideId +'" type="button">' + controlsText[1] + '</button></div>');

        [].forEach.call(wrapper.children, function (el) {
          if (el.getAttribute('data-tns-role') === 'controls') { controlsContainer = el; }
        });
        prevButton = controlsContainer.children[0];
        nextButton = controlsContainer.children[1];
      }
    }
  }

  function navInit() {
    if (nav) {
      if (options.navContainer) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(navContainer, {'aria-label': 'Carousel Pagination'});
        navItems = navContainer.children;
        [].forEach.call(navItems, function (item, index) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(item, {
            'data-nav': index,
            'tabindex': '-1',
            'aria-selected': 'false',
            'aria-controls': slideId + '-item' + index,
          });
        });
      } else {
        var navHtml = '';
        for (var i = 0; i < slideCount; i++) {
          navHtml += '<button data-nav="' + i +'" tabindex="-1" aria-selected="false" aria-controls="' + slideId + '-item' + i +'" type="button"></button>';
        }
        navHtml = '<div data-tns-role="nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__bower_components_go_native_src_gn_append__["a" /* append */])(wrapper, navHtml);

        [].forEach.call(wrapper.children, function (el) {
          if (el.getAttribute('data-tns-role') === 'nav') { navContainer = el; }
        });
        navItems = navContainer.children;

        // hide navs
        for (var j = navCountVisible; j < slideCount; j++) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(navItems[j], {'hidden': ''});
        }

        // update navCountVisibleCached
        navCountVisibleCached = navCountVisible;
      }

    }
  }

  function autoplayInit() {
    if (autoplay) {
      if (autoplayButton) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(autoplayButton, {'data-action': 'stop'});
      } else {
        if (!navContainer) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__bower_components_go_native_src_gn_append__["a" /* append */])(wrapper, '<div data-tns-role="nav" aria-label="Carousel Pagination"></div>');
          navContainer = wrapper.querySelector('[data-tns-role="nav"]');
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__bower_components_go_native_src_gn_append__["a" /* append */])(navContainer, '<button data-action="stop" type="button">' + autoplayHtmlString + autoplayText[0] + '</button>');
        autoplayButton = navContainer.querySelector('[data-action]');
      }

      // start autoplay
      startAction();
    }
  }

  function activateSlider() {
    for (var i = index; i < index + items; i++) {
      var item = slideItems[i];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(item, {'aria-hidden': 'false'});
      if (mode === 'gallery') { 
        item.style.left = slideWidth * (i - index) + 'px'; 
        item.classList.remove(animateNormal);
        item.classList.add(animateIn);
      }
    }
    if (controls) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(nextButton, {'tabindex': '0'});
      if (index === indexMin && !loop || rewind) {
        prevButton.disabled = true;
      }
    }
    if (nav) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(navItems[0], {'tabindex': '0', 'aria-selected': 'true'});
    }
  }

  function addSliderEvents() {
    if (mode === 'carousel') {
      if (TRANSITIONEND) {
        var eve = {};
        eve[TRANSITIONEND] = onTransitionEnd;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(container, eve);
      }
      if (touch) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(container, {
          'touchstart': onTouchOrMouseStart,
          'touchmove': onTouchOrMouseMove,
          'touchend': onTouchOrMouseEnd,
          'touchcancel': onTouchOrMouseEnd
        });
      }
      if (mouseDrag) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(container, {
          'mousedown': onTouchOrMouseStart,
          'mousemove': onTouchOrMouseMove,
          'mouseup': onTouchOrMouseEnd,
          'mouseleave': onTouchOrMouseEnd
        });
      }
    }

    if (nav) {
      for (var y = 0; y < slideCount; y++) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(navItems[y],{
          'click': onClickNav,
          'keydown': onKeydownNav
        });
      }
    }

    if (controls) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(prevButton,{
        'click': onClickPrev,
        'keydown': onKeydownControl
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(nextButton,{
        'click': onClickNext,
        'keydown': onKeydownControl
      });
    }

    if (autoplay) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(autoplayButton, {'click': toggleAnimation});
      if (autoplayHoverPause) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(container, {'mouseover': function () {
          if (animating) { 
            stopAction(); 
            autoplayHoverStopped = true;
          }
        }});
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(container, {'mouseout': function () {
          if (!animating && autoplayHoverStopped) { 
            startAction(); 
            autoplayHoverStopped = false;
          }
        }});
      }

      if (autoplayResetOnVisibility) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(document, {'visibilitychange': onVisibilityChange});
      }
    }

    if (arrowKeys) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(document, {'keydown': onKeydownDocument});
    }

    if (nested === 'inner') {
      events.on('outerResized', function () {
        resizeTasks();
        events.emit('innerLoaded', info());
      });
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(window, {'resize': onResize});
      if (nested === 'outer') {
        events.on('innerLoaded', runAutoHeight);
      }
    }
  }

  // lazyload
  function lazyLoad() {
    // var arr = [], 
    var i = index, 
        len = index + items;
        
    if (edgePadding) {
      i -=1;
      len +=1;
    }

    for(; i < len; i++) {
      [].forEach.call(slideItems[i].querySelectorAll('[data-tns-role="lazy-img"]'), function (img) {
        // stop propagationl transitionend event to container
        var eve = {};
        eve[TRANSITIONEND] = function (e) { e.stopPropagation(); };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(img, eve);

        if (!img.classList.contains('loaded')) {
          img.src = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_getAttr__["a" /* getAttr */])(img, 'data-src');
          img.classList.add('loaded');
        }
      });
    }
  }

  // check if all visible images are loaded
  // and update container height if it's done
  function runAutoHeight() {
    // get all images inside visible slide items
    var images = [];

    for (var i = index; i < index + items; i++) {
      [].forEach.call(slideItems[i].querySelectorAll('img'), function (img) {
        images.push(img);
      });
    }

    if (images.length === 0) {
      updateContainerHeight(); 
    } else {
      checkImagesLoaded(images);
    }
  }

  function checkImagesLoaded(images) {
    images.forEach(function (img, index) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__helpers_imageLoaded__["a" /* imageLoaded */])(img)) { images.splice(index, 1); }
    });

    if (images.length === 0) {
      updateContainerHeight();
    } else {
      setTimeout(function () { 
        checkImagesLoaded(images); 
      }, 16);
    }
  } 

  function sliderInit() {
    // First thing first, wrap container with "wrapper > contentWrapper",
    // to get the correct view width
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__bower_components_go_native_src_gn_wrap__["a" /* wrap */])(container, contentWrapper);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__bower_components_go_native_src_gn_wrap__["a" /* wrap */])(contentWrapper, wrapper);

    getVariables();
    containerInit();
    slideItemsInit();
    getSlideEdges();

    wrapperInit();
    containerInitStyle();
    msInit();
    controlsInit();
    navInit();
    autoplayInit();

    activateSlider();
    addSliderEvents();
    checkSlideCount();

    if (lazyload) { lazyLoad(); }
    if (autoHeight) { runAutoHeight(); }

    if (typeof onInit === 'function') {
      onInit(info());
    }

    if (nested === 'inner') { 
      events.emit('innerLoaded', info()); 
    }
  }
  sliderInit();

  // (vw) => edgePadding
  function getFixedWidthEdgePadding() {
    return (vw%slideWidth + gutter) / 2;
  }

  // update container height
  // 1. get the max-height of the visible slides
  // 2. set transitionDuration to speed
  // 3. update container height to max-height
  // 4. set transitionDuration to 0s after transition done
  function updateContainerHeight() {
    var heights = [], maxHeight;
    for (var i = index; i < index + items; i++) {
      heights.push(slideItems[i].offsetHeight);
    }
    maxHeight = Math.max.apply(null, heights);

    if (container.style.height !== maxHeight) {
      if (TRANSITIONDURATION) { setDurations(speed); }
      container.style.height = maxHeight + 'px';
    }
  }

  // get the distance from the top edge of the first slide to each slide
  // (init) => slideEdges
  function getSlideEdges() {
    slideEdges = [0];
    var topFirst = slideItems[0].getBoundingClientRect()[transformAttrLegacy], attr;
    for (var i = 1; i < slideCountNew; i++) {
      attr = slideItems[i].getBoundingClientRect()[transformAttrLegacy];
      slideEdges.push(attr - topFirst);
    }
  }

  // get wrapper height
  // (slideEdges, index, items) => vertical_conentWrapper.height
  function getVerticalWrapperHeight() {
    return slideEdges[index + items] - slideEdges[index];
  }

  // set snapInterval (for IE10)
  function setSnapInterval() {
    wrapper.style.msScrollSnapPointsX = 'snapInterval(0%, ' + slideWidth + ')';
  }

  // update slide
  function updateSlideStatus() {
    var h1, h2, v1, v2;
    if (index !== indexCached) {
      if (index > indexCached) {
        h1 = indexCached;
        h2 = Math.min(indexCached + items, index);
        v1 = Math.max(indexCached + items, index);
        v2 = index + items;
      } else {
        h1 = Math.max(index + items, indexCached);
        h2 = indexCached + items;
        v1 = index;
        v2 = Math.min(index + items, indexCached);
      }
    }

    if (slideBy%1 !== 0) {
      h1 = Math.round(h1);
      h2 = Math.round(h2);
      v1 = Math.round(v1);
      v2 = Math.round(v2);
    }

    for (var i = h1; i < h2; i++) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(slideItems[i], {'aria-hidden': 'true'});
    }
    for (var j = v1; j < v2; j++) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(slideItems[j], {'aria-hidden': 'false'});
    }
  }

  // set tabindex & aria-selected on Nav
  function updateNavStatus() {
    // get current nav
    if (nav) {
      if (navClicked === -1) {
        if (options.navContainer) {
          navCurrent = index%slideCount;
        } else {
          navCurrent = Math.floor(index%slideCount / items);
          // non-loop & reach the edge
          if (!loop && slideCount%items !== 0 && index === indexMax) { navCurrent += 1; }
        }
      } else {
        navCurrent = navClicked;
        navClicked = -1;
      }

      if (navCurrent !== navCurrentCached) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(navItems[navCurrentCached], {
          'tabindex': '-1',
          'aria-selected': 'false'
        });

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(navItems[navCurrent], {
          'tabindex': '0',
          'aria-selected': 'true'
        });
        navCurrentCached = navCurrent;
      }
    }
  }

  // set 'disabled' to true on controls when reach the edge
  function updateControlsStatus() {
    if (controls && !loop) {
      var disable = [], active = [];
      if (index === indexMin) {
        disable.push(prevButton);
        active.push(nextButton);
        changeFocus(prevButton, nextButton);
      } else if (!rewind && index === indexMax) {
        disable.push(nextButton);
        active.push(prevButton);
        changeFocus(nextButton, prevButton);
      } else {
        active.push(prevButton, nextButton);
      }

      if (disable.length > 0) {
        disable.forEach(function (button) {
          if (!button.disabled) {
            button.disabled = true;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(button, {'tabindex': '-1'});
          }
        });
      }

      if (active.length > 0) {
        active.forEach(function (button) {
          if (button.disabled) {
            button.disabled = false;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(button, {'tabindex': '0'});
          }
        });
      }
    }
  }

  // set duration
  function setDurations (duration, target) {
    duration = (!duration)? '' : duration / 1000 + 's';
    target = target || container;
    target.style[TRANSITIONDURATION] = duration;

    if (mode === 'gallery') {
      target.style[ANIMATIONDURATION] = duration;
    }
    if (axis === 'vertical') {
      contentWrapper.style[TRANSITIONDURATION] = duration;
    }
  }

  // make transfer after click/drag:
  // 1. change 'transform' property for mordern browsers
  // 2. change 'left' property for legacy browsers
  var transformCore = (function () {
    if (mode === 'carousel') {
      return function (duration, distance) {
        if (!distance) { distance = -slideEdges[index]; }
        // constrain the distance when non-loop no-edgePadding fixedWidth reaches the right edge
        if (hasRightDeadZone && index === indexMax) {
          distance = Math.max(distance, -slideCountNew * slideWidth + vw + gutter);
        }

        if (TRANSITIONDURATION || !duration) {
          container.style[transformAttr] = transformPrefix + Math.round(distance) + 'px' + transformPostfix;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__helpers_jsTransform__["a" /* jsTransform */])(container, transformAttr, transformPrefix, transformPostfix, distance, speed, onTransitionEnd);
        }

        if (axis === 'vertical') { contentWrapper.style.height = getVerticalWrapperHeight() + 'px'; }
      };
    } else {
      return function () {
        slideItemsOut = [];

        var eve1 = {};
        eve1[TRANSITIONEND] = onTransitionEnd;
        eve1[ANIMATIONEND] = onTransitionEnd;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__helpers_removeEvents__["a" /* removeEvents */])(slideItems[indexCached], eve1);

        var eve2 = {};
        eve2[TRANSITIONEND] = onTransitionEnd;
        eve2[ANIMATIONEND] = onTransitionEnd;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(slideItems[index], eve2);

        (function () {
          for (var i = indexCached, l = indexCached + items; i < l; i++) {
            var item = slideItems[i];
            if (TRANSITIONDURATION) { setDurations(speed, item); }
            if (animateDelay && TRANSITIONDELAY) {
              var d = animateDelay * (i - indexCached) / 1000; 
              item.style[TRANSITIONDELAY] = d + 's'; 
              item.style[ANIMATIONDELAY] = d + 's'; 
            }
            item.classList.remove(animateIn);
            item.classList.add(animateOut);
            slideItemsOut.push(item);
          }
        })();

        (function () {
          for (var i = index, l = index + items; i < l; i++) {
            var item = slideItems[i];
            if (TRANSITIONDURATION) { setDurations(speed, item); }
            if (animateDelay && TRANSITIONDELAY) {
              var d = animateDelay * (i - index) / 1000; 
              item.style[TRANSITIONDELAY] = d + 's'; 
              item.style[ANIMATIONDELAY] = d + 's'; 
            }
            item.classList.remove(animateNormal);
            item.classList.add(animateIn);
            if (i > index) { item.style.left = (i - index) * slideWidth + 'px'; }
          }
        })();
      };
    }
  })();

  function doTransform (duration, distance) {
    if (duration === undefined) { duration = speed; }
    if (TRANSITIONDURATION) { setDurations(duration); }
    transformCore(duration, distance);
  }

  // (slideBy, indexMin, indexMax) => index
  var checkIndex = (function () {
    if (loop) {
      return function () {
        var leftEdge = (mode === 'carousel')? slideBy + indexMin : indexMin, 
            rightEdge = (mode === 'carousel')? indexMax - slideBy : indexMax;

        if (fixedWidth && vw%slideWidth !== 0) { rightEdge -= 1; }

        if (index > rightEdge) {
          while(index >= leftEdge + slideCount) { index -= slideCount; }
        } else if(index < leftEdge) {
          while(index <= rightEdge - slideCount) { index += slideCount; }
        }
      };
    } else {
      return function () {
        index = Math.max(indexMin, Math.min(indexMax, index));
      };
    }
  })();

  function render() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(container, {'aria-busy': 'true'});
    if (checkIndexBeforeTransform) { checkIndex(); }

    // events
    if (index !== indexCached) { events.emit('indexChanged', info()); }
    events.emit('transitionStart', info());

    doTransform();
  }

  // AFTER TRANSFORM
  // Things need to be done after a transfer:
  // 1. check index
  // 2. add classes to visible slide
  // 3. disable controls buttons when reach the first/last slide in non-loop slider
  // 4. update nav status
  // 5. lazyload images
  // 6. update container height
  function onTransitionEnd(event) {
    events.emit('transitionEnd', info(event));

    if (mode === 'gallery' && slideItemsOut.length > 0) {
      for (var i = 0; i < items; i++) {
        var item = slideItemsOut[i];
        if (TRANSITIONDURATION) { setDurations(0, item); }
        if (animateDelay && TRANSITIONDELAY) { 
          item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = '';
        }
        item.classList.remove(animateOut);
        item.classList.add(animateNormal);
        item.style.left = '';
      }
    }

    /*
     * Transfer prefixed properties to the same format
     * CSS: -Webkit-Transform => webkittransform
     * JS: WebkitTransform => webkittransform
     * @param {string} str - property
     *
     */
    function strTrans(str) {
      return str.toLowerCase().replace(/-/g, '');
    }

    /*
     * update slides, nav, controls after checking ...
     *
     * => legacy browsers who don't support 'event' 
     *    have to check event first, otherwise event.target will cause an error 
     * 
     * => or 'gallery' mode: 
     *   + event target is slide item
     *
     * => or 'carousel' mode: 
     *   + event target is container, 
     *   + event.property is the same with transform attribute
     *
     */
    if (!event || 
        mode === 'gallery' && event.target.parentNode === container || 
        event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {

      if (!checkIndexBeforeTransform) { 
        var indexTem = index;
        checkIndex();
        if (index !== indexTem) { 
          doTransform(0); 
          events.emit('indexChanged', info());
        }
      } 

      updateSlideStatus();
      updateNavStatus();
      updateControlsStatus();
      if (lazyload) { lazyLoad(); }
      if (autoHeight) { runAutoHeight(); }

      if (nested === 'inner') { 
        events.emit('innerLoaded', info()); 
      } 
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(container, 'aria-busy');
      updateIndexCache();
    }

  }

  function updateIndexCache() {
    indexCached = index;
  }

  // # ACTIONS
  // on controls click
  function onClickControl(dir) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_getAttr__["a" /* getAttr */])(container, 'aria-busy') !== 'true') {
      index = index + dir * slideBy;

      render();
    }
  }

  function onClickPrev() {
    onClickControl(-1);
  }

  function onClickNext() {
    if(rewind && index === indexMax){
      onClickControl(-(indexMax - indexMin) / slideBy);
    }else{
      onClickControl(1);
    }
  }

  // on doc click
  function onClickNav(e) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_getAttr__["a" /* getAttr */])(container, 'aria-busy') !== 'true') {
      var clickTarget = e.target || e.srcElement, navIndex, indexGap;

      while (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__bower_components_go_native_src_gn_indexOf__["a" /* indexOf */])(navItems, clickTarget) === -1) {
        clickTarget = clickTarget.parentNode;
      }

      navIndex = navClicked = Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_getAttr__["a" /* getAttr */])(clickTarget, 'data-nav'));
      var adjust = (mode === 'gallery')? 0 : cloneCount;
      index = (options.navContainer) ? navIndex + adjust : navIndex * items + adjust;

      if (index !== indexCached) { render(); }
    }
  }

  function startAction() {
    resetActionTimer();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(autoplayButton, {'data-action': 'stop'});
    autoplayButton.innerHTML = autoplayHtmlString + autoplayText[1];

    animating = true;
  }

  function stopAction() {
    pauseActionTimer();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(autoplayButton, {'data-action': 'start'});
    autoplayButton.innerHTML = autoplayHtmlString.replace('Stop', 'Start') + autoplayText[0];

    animating = false;
  }

  function pauseActionTimer() {
    animating = 'paused';
    clearInterval(autoplayTimer);
  }

  function resetActionTimer() {
    if (animating === true) { return; }
    clearInterval(autoplayTimer);
    autoplayTimer = setInterval(function () {
      onClickControl(autoplayDirection);
    }, autoplayTimeout);
  }

  function toggleAnimation() {
    if (animating) {
      stopAction();
    } else {
      startAction();
    }
  }

  function onVisibilityChange() {
    if (autoplayResetVisibilityState != document.hidden && animating !== false) {
      document.hidden ? pauseActionTimer() : resetActionTimer();
    }
    autoplayResetVisibilityState = document.hidden;
  }

  // 
  function onKeydownDocument(e) {
    e = e || window.event;
    switch(e.keyCode) {
      case KEY.LEFT:
        onClickPrev();
        break;
      case KEY.RIGHT:
        onClickNext();
    }
  }

  // change focus
  function changeFocus(blur, focus) {
    if (typeof blur === 'object' && 
        typeof focus === 'object' && 
        blur === document.activeElement) {
      blur.blur();
      focus.focus();
    }
  }

  // on key control
  function onKeydownControl(e) {
    e = e || window.event;
    var code = e.keyCode,
        curElement = document.activeElement;

    switch (code) {
      case KEY.LEFT:
      case KEY.UP:
      case KEY.HOME:
      case KEY.PAGEUP:
        if (curElement !== prevButton && prevButton.disabled !== true) {
          changeFocus(curElement, prevButton);
        }
        break;
      case KEY.RIGHT:
      case KEY.DOWN:
      case KEY.END:
      case KEY.PAGEDOWN:
        if (curElement !== nextButton && nextButton.disabled !== true) {
          changeFocus(curElement, nextButton);
        }
        break;
      case KEY.ENTER:
      case KEY.SPACE:
        if (curElement === nextButton) {
          onClickNext();
        } else {
          onClickPrev();
        }
        break;
    }
  }

  // on key nav
  function onKeydownNav(e) {
    e = e || window.event;
    var code = e.keyCode,
        curElement = document.activeElement,
        dataSlide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_getAttr__["a" /* getAttr */])(curElement, 'data-nav');

    switch(code) {
      case KEY.LEFT:
      case KEY.PAGEUP:
        if (dataSlide > 0) { changeFocus(curElement, curElement.previousElementSibling); }
        break;
      case KEY.UP:
      case KEY.HOME:
        if (dataSlide !== 0) { changeFocus(curElement, navItems[0]); }
        break;
      case KEY.RIGHT:
      case KEY.PAGEDOWN:
        if (dataSlide < navCountVisible - 1) { changeFocus(curElement, curElement.nextElementSibling); }
        break;
      case KEY.DOWN:
      case KEY.END:
        if (dataSlide < navCountVisible - 1) { changeFocus(curElement, navItems[navCountVisible - 1]); }
        break;
      case KEY.ENTER:
      case KEY.SPACE:
        onClickNav(e);
        break;
    }
  }

  // IE10 scroll function
  function ie10Scroll() {
    doTransform(0, container.scrollLeft());
    updateIndexCache();
  }

  function getTarget(e) {
    return e.target || e.srcElement;
  }

  function isLinkElement(el) {
    return el.tagName.toLowerCase() === 'a';
  }

  function preventDefaultBehavior(e) {
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
  }

  function onTouchOrMouseStart(e) {
    e = e || window.event;
    if (isLinkElement(getTarget(e))) { preventDefaultBehavior(e); }

    var ev = (e.type === 'touchstart') ? e.changedTouches[0] : e;
    startX = parseInt(ev.clientX);
    startY = parseInt(ev.clientY);
    var slices = (TRANSFORM)? [11, -3] : [0, -2];
    translateInit = Number(container.style[transformAttr].slice(slices[0], slices[1]));

    if (e.type === 'touchstart') {
      events.emit('touchStart', info(e));
    } else {
      events.emit('dragStart', info(e));
      mousePressed = true;
    }
  }

  function onTouchOrMouseMove(e) {
    e = e || window.event;

    // "mousemove" event after "mousedown" indecate it's "drag", not "click"
    // set isDragEvent to true
    if (mousePressed && e.type === 'mousemove' && !isDragEvent) {
      isDragEvent = true;
    }
    
    // console.log(e.type, mousePressed, isDragEvent, e.clientX);
    // make sure touch started or mouse draged
    if (startX !== null) {
      if (isLinkElement(getTarget(e))) { preventDefaultBehavior(e); }

      var ev = (e.type === 'touchmove') ? e.changedTouches[0] : e;
      disX = parseInt(ev.clientX) - startX;
      disY = parseInt(ev.clientY) - startY;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_getTouchDirection__["a" /* getTouchDirection */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_toDegree__["a" /* toDegree */])(disY, disX), 15) === axis) { 
        touchedOrDraged = true;

        if (e.type === 'touchmove') {
          events.emit('touchMove', info(e));
        } else {
          events.emit('dragMove', info(e));
        }

        var x = (axis === 'horizontal')? (translateInit + disX) : (translateInit + disY);
            x += 'px';

        if (TRANSFORM) {
          x = 'translate' + transformDir + '(' + x + ')';
          setDurations(0);
        }
        container.style[transformAttr] = x;
      }
    }
  }

  function onTouchOrMouseEnd(e) {
    e = e || window.event;

    // reset mousePressed
    if (mousePressed) { mousePressed = false; }

    if (touchedOrDraged) {
      touchedOrDraged = false;

      var ev = (e.type.indexOf('touch') === 0) ? e.changedTouches[0] : e;
      disX = parseInt(ev.clientX) - startX;
      disY = parseInt(ev.clientY) - startY;

      // reset startX, startY
      startX = startY = null;

      if (axis === 'horizontal') {
        index = - (translateInit + disX) / slideWidth;
        index = (disX > 0) ? Math.floor(index) : Math.ceil(index);
      } else {
        var moved = - (translateInit + disY);
        if (moved <= 0) {
          index = indexMin;
        } else if (moved >= slideEdges[slideEdges.length - 1]) {
          index = indexMax;
        } else {
          var i = 0;
          do {
            i++;
            index = (disY < 0) ? i + 1 : i;
          } while (i < slideCountNew && moved >= Math.round(slideEdges[i + 1]));
        }
      }
      
      if (e.type.indexOf('touch') === 0) {
        events.emit('touchEnd', info(e));
      } else {
        events.emit('dragEnd', info(e));
      }

      render();
    }

    // drag vs click?
    if (isDragEvent) { 
      // reset isDragEvent
      isDragEvent = false;

      // prevent "click"
      var target = getTarget(e);
      if (isLinkElement(target)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_addEvents__["a" /* addEvents */])(target, {'click': function preventClick(e) {
          preventDefaultBehavior(e);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__helpers_removeEvents__["a" /* removeEvents */])(target, {'click': preventClick});
        }}); 
      }
    } 
  }

  // === RESIZE FUNCTIONS === //
  // (slideWidth) => container.width, slide.width
  function updateSlideWidth() {
    container.style.width = (slideWidth + 1) * slideCountNew + 'px'; // + 1 => fix half-pixel issue
    for (var i = slideCountNew; i--;) {
      slideItems[i].style.width = (slideWidth - gutter) + 'px';
    }
  }

  // (slideWidth, index, items) => gallery_visible_slide.left
  function updateSlidePosition() {
    for (var i = index + 1, len = index + items; i < len; i++) {
      slideItems[i].style.left = slideWidth * (i - index) + 'px';
    }
  }

  // (vw) => fixedWidth_contentWrapper.edgePadding
  function updateFixedWidthEdgePadding() {
    contentWrapper.style.cssText = 'margin: 0px ' + getFixedWidthEdgePadding() + 'px';
  }

  // (slideEdges, index, items) => vertical_conentWrapper.height
  function updateContentWrapperHeight() {
    contentWrapper.style.height = getVerticalWrapperHeight() + 'px';
  }

  // show or hide nav
  // (navCountVisible) => nav.[hidden]
  function updateNavDisplay() {
    if (navCountVisible !== navCountVisibleCached) {
      if (navCountVisible > navCountVisibleCached) {
        for (var i = navCountVisibleCached; i < navCountVisible; i++) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(navItems[i], 'hidden');
        }
      } else {
        for (var j = navCountVisible; j < navCountVisibleCached; j++) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_setAttrs__["a" /* setAttrs */])(navItems[j], {'hidden': ''});
        }
      }
    }
    navCountVisibleCached = navCountVisible;
  }

  function info(e) {
    return {
      container: container,
      slideItems: slideItems,
      navItems: navItems,
      prevButton: prevButton,
      nextButton: nextButton,
      items: items,
      index: index,
      indexCached: indexCached,
      navCurrent: navCurrent,
      navCurrentCached: navCurrentCached,
      slideCount: slideCount,
      cloneCount: cloneCount,
      slideCountNew: slideCountNew,
      event: e || {},
    };
  }

  function resizeTasks() {
    var indexTem = index,
        itemsTem = items;
    getVariables();
    checkSlideCount();
    checkIndex();

    if (axis === 'horizontal') {
      if (fixedWidth && edgePadding) {
        updateFixedWidthEdgePadding();
      } else {
        updateSlideWidth();

        if (mode === 'gallery') {
          updateSlidePosition(); 
        }
      }
      getSlideEdges();
    } else {
      getSlideEdges();
      updateContentWrapperHeight();
    }

    if (index !== indexTem) { 
      events.emit('indexChanged', info());
      updateSlideStatus();
      if (controls && !loop) { updateControlsStatus(); }
    }

    if (nav && items !== itemsTem && !options.navContainer) { 
      updateNavDisplay(); 
      updateNavStatus();
    } 

    if (index !== indexTem || mode === 'carousel' && !fixedWidth) { doTransform(0); }
    if (autoHeight) { runAutoHeight(); }
    if (lazyload && index !== indexTem || items !== itemsTem) { lazyLoad(); }

    if (navigator.msMaxTouchPoints) { setSnapInterval(); }
  }

  function onResize(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (vw !== getViewWidth()) {
        resizeTasks();
        if (nested === 'outer') { 
          events.emit('outerResized', info(e)); 
        }
      }
    }, 100); // update after stop resizing for 100 ms
  }

  return {
    getInfo: info,
    events: events,
    goTo: function (targetIndex) {
      // ** goal: renew index and render smoothly **

      // if target is prev or next, 
      // get the index right away
      if (targetIndex === 'next') {
        index += 1;
      } else if (targetIndex === 'prev' || targetIndex === 'previous' ) {
        index -= 1;
      } else {
      // if target is not prev or next, 
      // get index by comparing absolute target index and absolute index

        // get: absolute index
        var absIndex = index%slideCount, absTargetIndex;
        if (absIndex < 0) { absIndex += slideCount; }

        // get: absolute target index
        if (targetIndex === 'first') {
          absTargetIndex = 0;
        } else if (targetIndex === 'last') {
          absTargetIndex = slideCount - 1;
        } else if (typeof targetIndex === 'number') {
          absTargetIndex = targetIndex%slideCount;
        }
        if (absTargetIndex < 0) { absTargetIndex += slideCount; }

        // get index
        index += absTargetIndex - absIndex;
      }

      // if index is changed, check it and render
      if (index !== indexCached) {
        checkIndex();
        render();
      }

    },

    destory: function () {
      // wrapper
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__bower_components_go_native_src_gn_unwrap__["a" /* unwrap */])(wrapper);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__bower_components_go_native_src_gn_unwrap__["a" /* unwrap */])(contentWrapper);
      wrapper = contentWrapper = null;

      // container
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(container, ['id', 'style', 'data-tns-role', 'data-tns-features']);

      // cloned items
      if (loop) {
        for (var j = cloneCount; j--;) {
          slideItems[0].remove();
          slideItems[slideItems.length - 1].remove();
        }
      }

      // Slide Items
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(slideItems, ['id', 'style', 'aria-hidden']);
      slideId = slideCount = null;

      // controls
      if (controls) {
        if (!options.controlsContainer) {
          controlsContainer.remove();
          controlsContainer = prevButton = nextButton = null;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(controlsContainer, ['aria-label']);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(controlsContainer.children, ['aria-controls', 'tabindex']);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_removeEventsByClone__["a" /* removeEventsByClone */])(controlsContainer);
        }
      }

      // nav
      if (nav) {
        if (!options.navContainer) {
          navContainer.remove();
          navContainer = null;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(navContainer, ['aria-label']);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_removeAttrs__["a" /* removeAttrs */])(navItems, ['aria-selected', 'aria-controls', 'tabindex']);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_removeEventsByClone__["a" /* removeEventsByClone */])(navContainer);
        }
        navItems = null;
      }

      // auto
      if (autoplay) {
        if (!options.navContainer && navContainer !== null) {
          navContainer.remove();
          navContainer = null;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_removeEventsByClone__["a" /* removeEventsByClone */])(autoplayButton);
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__helpers_removeEvents__["a" /* removeEvents */])(document, {'visibilitychange': onVisibilityChange});
      }

      // remove slider container events at the end
      // because this will make container = null
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_removeEventsByClone__["a" /* removeEventsByClone */])(container);

      // remove arrowKeys eventlistener
      if (arrowKeys) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__helpers_removeEvents__["a" /* removeEvents */])(document, {'keydown': onKeydownDocument});
      }

      // remove window event listeners
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__helpers_removeEvents__["a" /* removeEvents */])(window, {'resize': onResize});
    },

    // $ Private methods, for test only
    // hasAttr: hasAttr, 
    // getAttr: getAttr, 
    // setAttrs: setAttrs, 
    // removeAttrs: removeAttrs, 
    // removeEventsByClone: removeEventsByClone, 
    // getSlideId: getSlideId, 
    // toDegree: toDegree, 
    // getTouchDirection: getTouchDirection, 
    // hideElement: hideElement, 
    // showElement: showElement,
  };
}


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _amplitudeInitVanilla = __webpack_require__(2);

var _amplitudeInitVanilla2 = _interopRequireDefault(_amplitudeInitVanilla);

var _functionsVanilla = __webpack_require__(1);

var functions = _interopRequireWildcard(_functionsVanilla);

var _tinySlider = __webpack_require__(75);

var _wistia = __webpack_require__(120);

var wistia = _interopRequireWildcard(_wistia);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOME_VIDEO_HANDLE = "wistia-handle";

var init = exports.init = function init() {
  (0, _amplitudeInitVanilla2.default)("homepage", { trackScrolling: true });

  var slider = (0, _tinySlider.tns)({
    container: document.querySelector("#review-slider"),
    items: 1,
    slideBy: "page",
    autoplay: true,
    navContainer: document.querySelector("#nav-container")
  });

  document.querySelector(".js_next").addEventListener("click", function (e) {
    slider.goTo("next");
  });

  document.querySelector(".js_prev").addEventListener("click", function (e) {
    slider.goTo("prev");
  });

  functions.embbedSvgImages();
};

document.addEventListener("DOMContentLoaded", init);

var loadHomepageVideo = function loadHomepageVideo() {
  var videoContainer = document.querySelector(".video-container");
  wistia.load();
  wistia.embedVideo(HOME_VIDEO_HANDLE, function (video) {
    var videoCover = document.querySelector(".video-cover");

    videoCover.style.cursor = "pointer";
    videoCover.addEventListener("click", function (e) {
      e.preventDefault();
      e.target.style.display = "none";
      videoContainer.style.display = "inline-block";
      video.play();
    });
  });
};

window.addEventListener("load", loadHomepageVideo);

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// /assets/js/home.75c8cb75969637cc55ec.js